import cx from 'classnames';
import React, { useContext } from 'react';
import { CSSTransition } from 'react-transition-group';

import KeyboardContext from '../keyboard-context';
import { KEYBOARD_TYPES } from '../types';

import './keyboard_type_secondary.scss';

interface Props {
    mix?: string;
    wrapperMix?: string;
}

export const SecondaryKeyboard = ({ mix, wrapperMix }: Props) => {
    const context = useContext(KeyboardContext);
    const { shouldShowKeyboard, setRef } = context[KEYBOARD_TYPES.SECONDARY];

    return (
        <div className={cx('keyboard__wrapper_type_secondary', wrapperMix)}>
            <CSSTransition
                classNames="keyboard__animation_type_secondary"
                in={shouldShowKeyboard}
                mountOnEnter={true}
                timeout={300}
                unmountOnExit={true}
            >
                <div className={cx('keyboard_type_secondary', mix)}>
                    <div className="keyboard__portal" ref={setRef} />
                </div>
            </CSSTransition>
        </div>
    );
};

export default SecondaryKeyboard;
